class CorporateFields {
	constructor() {

		this.initEventListeners()
	}

	initEventListeners() {
		$('[data-corporate-account]').on('click', this.toggleCorporateFields.bind(this));
	}

	toggleCorporateFields(e) {
		$('[data-corporate-account-display]').each((it, el) => {
			if ($(e.currentTarget).is(':checked')) {
				return $(el).closest('.form-group').removeClass('d-none');
			}

			$(el).closest('.form-group').addClass('d-none');
		});
	}
}

export default new CorporateFields;